module.exports = "/_next/static/images/Cover@2x-b8cf0bdac46dda031addcbe65610610d.png";